<template>
  <div style="margin-top: 0.7rem">
    <div class="meaasgeTitle">
      <div>
        <!-- 分类导航 -->
        <div style="display: flex;justify-content: space-between;align-items: center;">
          <div class="meaasgeTitle_">
            <div v-for="(item, index) in meaasgeTitle_list" :class="item.checked == true
              ? 'meaasgeTitle_listClickY'
              : 'meaasgeTitle_listClickN'
              " :key="index">
              <el-badge @click="meaasgeTitleNavClick(index, item)" :value="item.value" :max="item.value" class="item"
                :hidden="item.value == 0">
                <img :src="item.img" alt="" />
              </el-badge>
              <p>{{ item.title }}</p>
              <div class="meaasgeTitle_listClickY_select meaasgeTitle_listClickY_selectNo"></div>
            </div>
          </div>
          <div class="" @click="HRU_list_qbyd"
            style="width: 120px;height:40px;background: #ffffff;text-align: center;line-height: 40px;border-radius: 12px;color: #2978ff;display: flex;column-gap: 5px;align-items: center;justify-content: center;cursor: pointer;">
            <div><img src="@/assets/qk.png" alt="" style="width: 15px;height: 15px;vertical-align: sub;" srcset="">
            </div>
            <div><span>全部已读</span></div>
          </div>
        </div>

        <!-- 系统通知 -->
        <div class="meaasgeTitle_xttz_list" v-if="meaasgeTitleNavNumber === 'xttz'">
          <div v-if="meaasgeTitle_list_xttz.length" v-for="(item, index) in meaasgeTitle_list_xttz" :key="index"
            class="message-item">
            <!-- 使用条件运算符来设置 src 属性 -->
            <img class="MT_dz_list_imgUser" :src="item.avatar1 ? item.avatar1 : require(`@/assets/Frame33.png`)
              " />
            <div class="message-content">
              <!-- 简化显示昵称和创建时间的逻辑 -->
              <p class="MTXL_time">
                {{
                  item.nickName1
                  ? `${item.nickName1} ${item.createTime}`
                  : `系统通知 ${item.createTime}`
                }}
              </p>
              <!-- 使用 :style 指令来进行条件颜色样式设置 -->
              <p class="MTXL_title">
                <span :style="{ color: item.status == 1 ? '#86909C' : '#3fa4ed' }">{{
                  item.noticeTitle ? item.noticeTitle : item.noticeContent
                }}</span>
                <!-- 使用 template 来遍历 detailLinks -->
                <template v-for="(link, key) in detailLinks">
                  <span v-if="key === item.code" class="link-container">
                    <!-- 简化点击事件处理程序 -->
                    <!-- 3fa4ed -->
                    <div @click="goToDetail(link.path, link.query, item)" :style="{
                      color: item.status == 1 ? '#86909C' : '#3fa4ed',
                    }">
                      查看详情 >>
                    </div>
                    <!-- 如果需要，取消下面的注释 -->
                    <!-- <div v-if="item.status === 1" class="delete-action">
              删除
            </div> -->
                  </span>
                </template>
              </p>
            </div>
          </div>
          <!-- 使用 Vue 的 v-else 指令来进行条件渲染 -->
          <div style="width: 100%; height: 5rem" v-else>
            <img style="
                position: absolute;
                top: 50%;
                left: 50%;
                width: 45%;
                height: 100%;
                color: #ccc;
                transform: translate(-50%, -50%);
              " src="@/assets/zt_zanwushuju.png" />
            <span style="
                position: absolute;
                top: 80%;
                left: 50%;
                color: #ccc;
                transform: translate(-50%, -50%);
              ">
              暂无消息
            </span>
          </div>
        </div>

        <!-- 点赞 -->
        <div class="meaasgeTitle_dz_list" v-if="meaasgeTitleNavNumber == 'dz'">
          <div class="MT_dz_list">
            <div v-if="meaasgeTitle_list_dz.length" v-for="index in meaasgeTitle_list_dz" :key="index">
              <div>
                <img class="MT_dz_list_imgUser" :src="index.avatar ? index.avatar : require('@/assets/logo.png')
                  " alt="" />
                <div>
                  <p class="MT_dz_list_name">
                    {{ index.nickName }}
                    <span class="MT_dz_list_time">
                      {{
                        com_date.com_date.timestamp_string(
                          index.createTime,
                          true,
                          "-",
                          ":"
                        )
                      }}</span>
                  </p>
                  <p class="MT_dz_list_z">{{ index.noticeContent }}</p>
                </div>
              </div>
              <img class="MT_dz_list_imgWorks" :src="JSON.parse(index.extendsData).showImage
                ? JSON.parse(index.extendsData).showImage
                : JSON.parse(index.extendsData).coverSheet
                " />
            </div>
            <div style="width: 100%; height: 5rem" v-else>
              <img style="
                  position: absolute;
                  top: 50%;
                  left: 50%;
                  width: 45%;
                  height: 100%;
                  color: #ccc;
                  transform: translate(-50%, -50%);
                " src="@/assets/zt_zanwushuju.png" />
              <span style="
                  position: absolute;
                  top: 80%;
                  left: 50%;
                  color: #ccc;
                  transform: translate(-50%, -50%);
                ">
                暂无消息
              </span>
            </div>
          </div>
        </div>
        <!-- 收藏 -->
        <div class="meaasgeTitle_sc_list" v-if="meaasgeTitleNavNumber == 'sc'">
          <div class="MT_dz_list">
            <div v-if="meaasgeTitle_list_dz.length" v-for="index in meaasgeTitle_list_dz" :key="index">
              <div>
                <img class="MT_dz_list_imgUser" :src="index.avatar ? index.avatar : require('@/assets/logo.png')
                  " alt="" />
                <div>
                  <p class="MT_dz_list_name">
                    {{ index.nickName }}
                    <span class="MT_dz_list_time">
                      {{
                        com_date.com_date.timestamp_string(
                          index.createTime,
                          true,
                          "-",
                          ":"
                        )
                      }}</span>
                  </p>
                  <p class="MT_dz_list_z">{{ index.noticeContent }}</p>
                </div>
              </div>
              <img class="MT_dz_list_imgWorks" style="width: 80px;height: 80px;object-fit: cover;border-radius: 12px;"
                :src="JSON.parse(index.extendsData).showImage
                  ? JSON.parse(index.extendsData).showImage
                  : JSON.parse(index.extendsData).coverSheet
                  " />
            </div>
            <div style="width: 100%; height: 5rem" v-else>
              <img style="
                  position: absolute;
                  top: 50%;
                  left: 50%;
                  width: 45%;
                  height: 100%;
                  color: #ccc;
                  transform: translate(-50%, -50%);
                " src="@/assets/zt_zanwushuju.png" />
              <span style="
                  position: absolute;
                  top: 80%;
                  left: 50%;
                  color: #ccc;
                  transform: translate(-50%, -50%);
                ">
                暂无消息
              </span>
            </div>
          </div>
        </div>
        <div class="meaasgeTitle_fs_list" v-if="meaasgeTitleNavNumber == 'fs'">
          <div class="MT_dz_list">
            <div v-if="meaasgeTitle_list_sc.length" v-for="index in meaasgeTitle_list_sc" :key="index">
              <div>
                <img class="MT_dz_list_imgUser" :src="index.avatar ? index.avatar : require('@/assets/logo.png')
                  " alt="" />
                <div>
                  <p class="MT_dz_list_name">
                    {{ index.memberName }}
                    <span class="MT_dz_list_time">{{ index.followTime }}</span>
                  </p>
                  <p class="MT_dz_list_z" style="font-size: 0.12rem; color: #86909c">
                    关注了你
                  </p>
                </div>
              </div>
              <div>
                <!-- <button class="MTFS_list_lx" @click="Contact(index.memberId)">
                    联系
                  </button> -->
                <button class="MTFS_list_gz" @click="composer(index)">
                  进入主页
                </button>
              </div>
            </div>
            <div style="width: 100%; height: 5rem" v-else>
              <img style="
                  position: absolute;
                  top: 50%;
                  left: 50%;
                  width: 45%;
                  height: 100%;
                  color: #ccc;
                  transform: translate(-50%, -50%);
                " src="@/assets/zt_zanwushuju.png" />
              <span style="
                  position: absolute;
                  top: 80%;
                  left: 50%;
                  color: #ccc;
                  transform: translate(-50%, -50%);
                ">
                暂无消息
              </span>
            </div>
          </div>
          <strong></strong>
        </div>
        <!-- 分页 -->
        <div class="tac">
          <el-pagination v-model:current-page="page.pageNum" v-model:page-size="page.pageSize" @size-change="sizeChange"
            @current-change="currentChange" style="margin: 0.4rem 0" background layout="prev, pager, next"
            :total="page.total" />
        </div>
      </div>
    </div>
    <el-dialog title="" :show-close="false" v-model="payment" align-center width="4.8rem" :close-on-click-modal="false">
      <div class="zf_body">
        <div class="zf_body_top">
          <span>联系合作</span>
          <img @click="payment = false" class="cur" src="../../assets/module_share_open.png" />
        </div>
        <div class="zf_body_title">支付相应费用，获得联系方式</div>
        <div class="zf_b_M">
          <span CLASS="zf_b_M_title">应付金额：</span>
          <span class="zf_b_M_number"><text class="zf_b_M_n_icon">￥</text>{{ (moenyNumber / 1).toFixed(2) }}</span>
        </div>
        <div class="zf_fs_body">
          <div class="zf_fs_title">选择付款方式</div>
          <div class="zf_fs_list">
            <div v-for="index in paymentTypeList" :key="index" @click="paymentTL_click(index)">
              <img class="zf_fs_logo cur" :src="index.img" />
              <span>{{ index.title }}</span>
              <img v-if="index.checked" class="zf_fs_icon" src="../../assets/lxhz_icon.png" alt="" />
            </div>
          </div>
        </div>
        <div class="zf_fs_b">
          <div class="zf_fs_b_qx cur" @click="payment = false">取消</div>
          <div class="zf_fs_b_qd cur" @click="get_sjh(obj)">确定</div>
        </div>
      </div>
    </el-dialog>
    <two-dimensional-code ref="TwoDimensionalCodeRef" :CloseQrCode="CloseQrCode" />
    <el-dialog v-model="PartnersMobileNumber" align-center width="480px" :close-on-click-modal="false">
      <div style="text-align: center">联系方式</div>
      <div style="text-align: center; padding-top: 5px; font-size: 20px">
        {{ PartnersMobileNumber1 }}
      </div>
      <div style="display: flex; justify-content: center">
        <div class="dataBtnClose" @click="PartnersMobileNumber = false">
          取消
        </div>
        <div class="dataBtnSubmit" @click="PartnersMobileNumber = false">
          确认
        </div>
      </div>
    </el-dialog>
    <el-dialog v-model="show" align-center width="480px" :close-on-click-modal="false" title="系统通知">
      <div style="text-align: center">
        {{ showTitle ? showTitle : "系统通知" }}
      </div>
      <div v-html="showHtml" style="text-align: center; padding-top: 5px; font-size: 14px"></div>
      <!-- <div style="display: flex; justify-content: center">
        <div class="dataBtnClose" @click="show = false">取消</div>
        <div class="dataBtnSubmit" @click="show = false">确认</div>
      </div> -->
    </el-dialog>
    <details-of-works ref="DetailsOfWorksRef" :CloseQrCode1="CloseQrCode1" />
  </div>
</template>

<script lang="ts" setup>
import { onMounted, ref, watch } from "vue";
import { useRouter, useRoute } from "vue-router";
import { Axios } from "@/assets/js/ls_com_axios.js";
import { ElMessage, ElLoading } from "element-plus";
import { useStore } from "vuex";
const store = useStore();
const router = useRouter();
const route = useRoute();
import DetailsOfWorks from "@/views/ShadowUser/components/DetailsOfWorks.vue";
import TwoDimensionalCode from "@/views/ShadowComposer/components/TwoDimensionalCode.vue";
import com_date from "@/assets/js/common.js";
import { nextTick } from "process";
const TwoDimensionalCodeRef = ref<any>();
const CloseQrCode1 = () => { };
const DetailsOfWorksRef = ref();
const DetailsOfWorksClick = (item) => {
  DetailsOfWorksRef.value.init(item.id);
};
const detailLinks = ref({
  material_order: { path: "/myOrder" },
  material_order1: { path: "/myOrder" },
  material_order2: { path: "/onSaleMaterial" },
  material_order3: { path: "/requirementPublish" },
  material_order4: { path: "/ShadowBusinessList" },
  material_order5: { path: "/requirementPublish", query: { ccNum: 2 } },
  material_order6: { path: "/requirementPublish" },
  material_order7: { path: "/requirementPublish" },
  need_publish: { path: "/requirementPublish" },
  need_signUp: { path: "/requirementPublish", query: { state: "first1" } },
  need_signBill: { path: "/requirementPublish", query: { state: "first" } },
  material_audit_s: { path: "/onSaleMaterial" },
  material_audit_f: { path: "/newTrialMaterial" },
  need_signRefuse: {
    path: "/requirementPublish",
    query: { state: "four" },
  },
  need_choice: {
    path: "/requirementManagement",
    query: { state: "first" },
  },
  need_pay_A: { path: "/requirementPublish", query: { state: "first" } },
  need_pay_B: {
    path: "/requirementManagement",
    query: { state: "second" },
  },
  need_settlement: {
    path: "/requirementManagement",
    query: { state: "four" },
  },
  need_refundSuccess: {
    path: "/requirementPublish",
    query: { state: "four3" },
  },
  need_refundFailed: {
    path: "/requirementPublish",
    query: { state: "four3" },
  },
  need_confirm: {
    path: "/requirementPublish",
    query: { state: "second" },
  },
  need_finish: {
    path: "/requirementPublish",
    query: { state: "second" },
  },
  work_like: {
    path: "/MessageBarList",
    query: { type: "1" },
  },
  work_favorite: {
    path: "/MessageBarList",
    query: { type: "2" },
  },
  follow: {
    path: "/MessageBarList",
    query: { type: "3" },
  },
  material_collect: {
    path: "/ShadowMaterialVideoParticulars",
    query: { id: "2" },
  },
  system_notice: {
    path: false,
  },
});

document.title = "标识山西-系统通知";
let pageDef = ref({
  pageNum: 1,
  pageSize: 5,
  total: 0,
});
let show = ref(false);
let showHtml = ref("<p></p>");
let showTitle = ref(null);
const init = () => {
  if (route.query.type) {
    nextTick(() => {
      meaasgeTitle_list.value[route.query.type].checked = true;
      meaasgeTitleNavClick(
        route.query.type / 1,
        meaasgeTitle_list.value[route.query.type]
      );
    });
  }
};
init();
const page = pageDef;
const HRU_list_qbyd = function () {
  // alert("全部已读待完成");
  Axios("post", `/system/notice/front/read`, {}, false, (res) => {
    // store.commit("SetSystemMessages", arr);
    getList();
    getList1(1);
    getList1(2);
    getList2();
    ElMessage.success("全部已读成功");
  });
};
const meaasgeTitle_list = ref([
  {
    img: require("../../assets/MessageBarList_xttz.png"),
    title: "系统通知",
    NumberX: "",
    value: 0,
    checked: true,
    MTNtitle: "xttz",
  },
  {
    img: require("../../assets/MessageBarList_dz.png"),
    title: "点赞",
    NumberX: "0",
    value: 0,
    checked: false,
    MTNtitle: "dz",
  },
  {
    img: require("../../assets/MessageBarList_sc.png"),
    title: "收藏",
    NumberX: "",
    value: 0,
    checked: false,
    MTNtitle: "sc",
  },
  {
    img: require("../../assets/MessageBarList_fs.png"),
    title: "粉丝",
    NumberX: "",
    value: 0,
    checked: false,
    MTNtitle: "fs",
  },
]);
const meaasgeTitle_list_xttz = ref([]);
const meaasgeTitle_list_dz = ref([
  // {
  //   headPortrait_img: require("../../assets/MessageBarList_fs.png"),
  //   userName: "吴洁丽",
  //   time: "2023-05-31 17:29",
  //   dz_number: 3,
  //   worksName: "大漠以北",
  //   worksImg: require("../../assets/LS1.png"),
  //   dz_imgList: [
  //     require("../../assets/MessageBarList_xttz.png"),
  //     require("../../assets/MessageBarList_xttz.png"),
  //     require("../../assets/MessageBarList_xttz.png"),
  //   ],
  // },
  // {
  //   headPortrait_img: require("../../assets/MessageBarList_fs.png"),
  //   userName: "吴洁丽2",
  //   time: "2023-05-31 17:29",
  //   dz_number: 0,
  //   worksName: "大漠以北",
  //   worksImg: require("../../assets/LS1.png"),
  // },
]);
const meaasgeTitle_list_sc = ref([
  {
    headPortrait_img: require("../../assets/MessageBarList_fs.png"),
    userName: "吴洁丽",
    time: "2023-05-31 17:29",
    dz_number: 3,
    worksName: "大漠以北",
    worksImg: require("../../assets/LS1.png"),
    dz_imgList: [
      require("../../assets/MessageBarList_xttz.png"),
      require("../../assets/MessageBarList_xttz.png"),
      require("../../assets/MessageBarList_xttz.png"),
    ],
  },
  {
    headPortrait_img: require("../../assets/MessageBarList_fs.png"),
    userName: "吴洁丽2",
    time: "2023-05-31 17:29",
    dz_number: 0,
    worksName: "大漠以北",
    worksImg: require("../../assets/LS1.png"),
  },
]);
const MTXL_titleindentID = function (index) {
  alert("模拟获取订单ID : " + index.indentID);
};
const composer = function (index) {
  router.push({
    path: "/ShadowComposerHomepage",
    query: { id: index.memberId },
  });
};
const loading = ref();
const meaasgeTitleNavClick = function (index, item) {
  loading.value = ElLoading.service({
    lock: true,
    text: "Loading",
    background: "rgba(0, 0, 0, 0.7)",
  });
  page.value.pageNum = 1;
  page.value.total = 1;

  for (let i = 0; i < meaasgeTitle_list.value.length; i++) {
    meaasgeTitle_list.value[i].checked = i === index;
    if (i === index) {
      meaasgeTitleNavNumber.value = item.MTNtitle;
      if (i === 0) {
        getList();
      } else if (i === 1 || i === 2) {
        getList1(i);
      } else {
        getList2();
      }
    }
  }
};

const initNum = () => {
  let type = router.currentRoute.value.query.type;
  type ? meaasgeTitleNavClick(type, meaasgeTitle_list.value[type]) : "";

  Axios("GET", "/system/notice/front/noread", {}, false, function (res) {
    meaasgeTitle_list.value[0].value = res.data.data;
    // console.log("111111", res.data.data);
    // getList();
  });

  Axios("GET", "/system/notice/front/noread-new", {}, false, function (res) {
    // meaasgeTitle_list.value[0].value = res.data.data;
    // console.log("resresresres", res.data.data);
    if (res.data.data.length) {
      meaasgeTitle_list.value[2].value = 0;
      res.data.data.forEach((e: any) => {
        if (e.code === "work_favorite" || e.code === "material_collect") {
          // 在累加前检查是否有值
          meaasgeTitle_list.value[2].value += e.count;
        }
        if (e.code === "work_like") {
          meaasgeTitle_list.value[1].value = e.count;
        }
        if (e.code === "follow") {
          meaasgeTitle_list.value[3].value = e.count;
        }
      });
    } else {
      meaasgeTitle_list.value.forEach((e) => {
        e.value = 0;
      });
    }
    loading.value ? loading.value.close() : "";
  });
};
initNum();
const goToDetail = (path: any, query = {}, item: any) => {
  let arr = [...store.state.SystemMessages];
  console.log(path);

  function removeObjectById(arr: any, id: any) {
    return arr.filter((obj: any) => obj.noticeId !== id);
  }

  Axios(
    "post",
    `/system/notice/front/one-read/${item.noticeId}`,
    {},
    false,
    function (res: any) {
      store.commit("SetSystemMessages", removeObjectById(arr, item.noticeId));
      if (!path) {
        showTitle.value = item.noticeTitle;
        showHtml.value = item.noticeContent;
        show.value = true;
        loading.value && loading.value.close();
        initNum();
        return;
      }
      if (item.code === "material_collect") {
        const extendsData = JSON.parse(item.extendsData);
        let url = "";

        switch (extendsData.materialType) {
          case 2:
            url = "/ShadowMaterialVideoParticulars";
            break;
          case 1:
            url = "/ShadowMaterialVideoMusic";
            break;
          case 0:
            url = "/ShadowMaterialVideoImage";
            break;
          default:
            // Handle default case
            break;
        }

        if (url != "/MessageBarList") {
          router.push({
            path: url,
            query: {
              id: extendsData.id,
            },
          });
        }
      } else if (item.code === "work_like" || item.code === "work_favorite") {
        const extendsData = JSON.parse(item.extendsData);
        DetailsOfWorksClick(extendsData);
      } else if (path == "/MessageBarList") {
        meaasgeTitle_list.value[query.type].checked = true;
        meaasgeTitleNavClick(
          query.type / 1,
          meaasgeTitle_list.value[query.type]
        );
      } else {
        router.push({
          path,
          query,
        });
      }
      initNum();
      loading.value && loading.value.close();
    }
  );
};

const meaasgeTitleNavNumber = ref("xttz");

const getList = () => {
  Axios(
    "GET",
    "/system/notice/front/list",
    {
      pageNum: page.value.pageNum,
      pageSize: page.value.pageSize,
      orderByColumn: "createTime",
      isAsc: "desc",
      // NoticeType: 3,
      // code: 'material_order,material_seller,need_refundSuccess,need_publish,need_signUp,need_choice,need_signBill,need_pay'
    },
    false,
    function (res) {
      res.data.rows.forEach((e) => {
        switch (e.code) {
          case "need_publish":
          case "material_order3":
          case "material_order5":
          case "material_order6":
          case "material_order7":
          case "need_signUp":
          case "need_signBill":
          case "need_signRefuse":
          case "need_pay_A":
          case "need_refundSuccess":
          case "need_refundFailed":
          case "need_confirm":
          case "need_finish":
          case "need_choice":
          case "need_pay_B":
          case "material_audit_s":
          case "material_audit_f":
          case "need_settlement":
            e.noticeTitle = e.noticeContent;
            break;
          case "work_like":
          case "work_favorite":
          case "follow":
            e.avatar1 = e.avatar;
            e.nickName1 = e.nickName;
            e.noticeContent = e.noticeContent || e.noticeTitle;
            break;
          case "material_collect":
            e.avatar1 = e.avatar;
            e.nickName1 = e.nickName;
            // e.noticeContent = e.noticeTitle;
            break;
          default:
            break;
        }
      });
      meaasgeTitle_list_xttz.value = res.data.rows;
      page.value.total = res.data.total;
      loading.value ? loading.value.close() : "";
    }
  );
};
const getList1 = (val) => {
  Axios(
    "GET",
    "/system/notice/front/list",
    {
      pageSize: page.value.pageSize,
      pageNum: page.value.pageNum,
      code: val == 2 ? "material_collect,work_favorite" : "work_like",
      type: val,
      isAsc: "desc",
      orderByColumn: "createTime",
    },
    false,
    function (res) {
      meaasgeTitle_list_dz.value = [];
      meaasgeTitle_list_dz.value = res.data.rows;
      page.value.total = res.data.total;
      loading.value ? loading.value.close() : "";
    }
  );
};
const getList2 = () => {
  let obj = { ...page.value };
  obj.orderByColumn = "followTime";
  obj.isAsc = "desc";
  obj.followId = JSON.parse(localStorage.getItem("userList")).memberId;
  Axios("GET", "/member/member-follow/list", obj, false, function (res) {
    meaasgeTitle_list_sc.value = res.data.rows;
    page.value.total = res.data.total;
    loading.value ? loading.value.close() : "";
  });
};
getList();
const typeT = () => {
  if (meaasgeTitleNavNumber.value === "xttz") {
    getList();
  } else if (meaasgeTitleNavNumber.value === "dz") {
    getList1(1);
  } else if (meaasgeTitleNavNumber.value === "sc") {
    getList1(2);
  } else {
    // getList();
    getList2();
  }
};
// 联系
const PartnersMobileNumber = ref(false);
const PartnersMobileNumber1 = ref();
let Contact = function (index) {
  Axios(
    "get",
    "/member/contacts/phone/" + index,
    {},
    false,
    function (res) {
      PartnersMobileNumber.value = true;
      PartnersMobileNumber1.value = res.data.msg;
      console.log("PartnersMobileNumber1.value ", PartnersMobileNumber1.value);
      console.log("PartnersMobileNumber1.value ", PartnersMobileNumber.value);
    },
    function (res) {
      ElMessage({
        showClose: true,
        message: res.data.msg,
        type: "warning",
      });
      console.log(res.data.data);

      getMoney(index);
    }
  );
};
let moenyNumber = ref(0);
let payment = ref(false);
let paymentTL_click = function (index) {
  for (let i = 0; i < paymentTypeList.value.length; i++) {
    if (index == paymentTypeList.value[i]) {
      paymentTypeList.value[i].checked = true;
    } else {
      paymentTypeList.value[i].checked = false;
    }
  }
};
// 支付类型列表
let paymentTypeList = ref([
  // {
  //   title: "我的账户",
  //   img: require("../../assets/lxhz_pb.png"),
  //   checked: true,
  // },
  {
    title: "微信",
    img: require("@/assets/lxhz_wx.png"),
    checked: true,
  },
  {
    title: "支付宝",
    img: require("@/assets/lxhz_zfb.png"),
    checked: false,
  },
]);
let obj = ref({});
let getMoney = function (index) {
  Axios("get", "/member/contacts/pay-amount", {}, false, function (res) {
    moenyNumber.value = res.data.msg;
    obj.value = {};
    obj.value = index;
    payment.value = true;
  });
};
// 支付获取联系方式
let get_sjh = function (obj) {
  let index = obj;
  Axios(
    "POST",
    "/member/contacts?memberId=" + index,
    {},
    false,
    function (res) {
      console.log(res.data);
    },
    function (res) {
      Axios(
        "POST",
        `/member/contacts/create-order/${index}`,
        {},
        false,
        function (res) {
          console.log();

          // console.log(res.data.data);
          TwoDimensionalCodeRef.value.init(
            res.data.data.qrcode,
            res.data.data.sceneId,
            index
          );
        },
        function (res) {
          console.log(res.data);
        }
      );
    }
  );
};
const CloseQrCode = (e) => {
  payment.value = false;
  Axios(
    "get",
    "/member/contacts/phone/" + e,
    {},
    false,
    function (res) {
      // res;
      PartnersMobileNumber.value = true;
      PartnersMobileNumber1.value = res.data.msg;
      // PartnersMobileNumber1.value = res.data.data.info.partyBContactInfo;
    },
    function (res) {
      console.log("没购买");
    }
  );
};
const currentChange = (val) => {
  loading.value = ElLoading.service({
    lock: true,
    text: "Loading",
    background: "rgba(0, 0, 0, 0.7)",
  });
  typeT();
};
// 在页面加载时和页面刷新后从本地存储中获取 messageCount 的值
onMounted(() => {
  const storedValue = localStorage.getItem("messageCount");
  if (storedValue !== null) {
    messageCount.value = parseInt(storedValue);
  }
});
const messageCount = ref(0);
// 监听 store.state.SystemMessages 变化
watch(
  () => store.state.SystemMessages,
  (newValue, oldValue) => {
    // 将数据存储到本地存储
    localStorage.setItem("systemMessages", JSON.stringify(newValue));

    // 调用方法，传入新旧值
    checkSystemMessages(newValue, oldValue);
  }
);

// 定义检查系统消息的方法
function checkSystemMessages(newValue, oldValue) {
  // 调用相应的方法
  function findDifference(arr1, arr2) {
    const noticeIds1 = arr1.map((item) => item.noticeId);
    const noticeIds2 = arr2.map((item) => item.noticeId);

    const uniqueToArr1 = noticeIds1.filter((id) => !noticeIds2.includes(id));
    const uniqueToArr2 = noticeIds2.filter((id) => !noticeIds1.includes(id));

    return {
      uniqueToArr1: uniqueToArr1,
      uniqueToArr2: uniqueToArr2,
    };
  }

  // 深度比较对象内容
  if (oldValue && JSON.stringify(newValue) !== JSON.stringify(oldValue)) {
    // 在这里调用你的方法

    setTimeout(function () {
      initNum();
    }, 2000);
    let diff = findDifference(oldValue, newValue);
    // 将状态置为0
    meaasgeTitle_list_xttz.value.forEach((e) => {
      console.log(diff.uniqueToArr1, e.noticeId);
      if (diff.uniqueToArr1.includes(e.noticeId)) {
        e.status = 0;
      }
    });
    if (messageCount.value) messageCount.value--;
    // 更新消息总数
  }
  if (newValue.length === 0) {
    console.log(111);
    meaasgeTitle_list.value.forEach((e) => {
      e.value = 0;
    });
    messageCount.value = 0;
    meaasgeTitle_list_xttz.value.forEach((e) => {
      e.status = 1;
    });
  }
}

// 在页面卸载前保存 messageCount 的值到本地存储
window.addEventListener("beforeunload", () => {
  localStorage.setItem("messageCount", messageCount.value.toString());
});
</script>

<style scoped>
.meaasgeTitle {
  height: 100%;
  background: #f5f5f5;
  display: block;
  padding-bottom: 0.4rem;
}

.meaasgeTitle>div {
  width: 12rem;
  height: 100%;
  margin: 0 auto;
  display: block;
}

.meaasgeTitle_ {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding-top: 0.4rem;
}

.meaasgeTitle_>div :hover,
.MTXL_title_span:hover {
  cursor: pointer;
}

.meaasgeTitle_>div {
  padding: 0 0.2rem;
  margin-right: 0.36rem;
  padding-bottom: 0.12rem;
  position: relative;
}

.meaasgeTitle_listClickY .meaasgeTitle_listClickY_select {
  width: 0.9rem !important;
  height: 0.14rem !important;
  background: url(/src/assets/MessageBarList_button.png);
  background-position: center;
  background-repeat: no-repeat;
  background-size: 100%;
  position: absolute;
  left: 0;
  right: 0;
  margin: auto;
}

.meaasgeTitle_listClickN .meaasgeTitle_listClickY_selectNo {
  width: 0.9rem !important;
  height: 0.14rem !important;

  position: absolute;
  left: 0;
  right: 0;
  margin: auto;
}

.meaasgeTitle_listClickN {
  /* border-bottom: 0.04rem solid #F5F5F5; */
}

.meaasgeTitle_>div img {
  width: 0.5rem;
  height: 0.5rem;
  margin-bottom: 0.08rem;
  border-radius: 50%;
}

.meaasgeTitle_>div>p {
  color: #4e5359;
  font-size: 0.14rem;
  text-align: center;
}

.el-badge__content {
  top: 0.05rem !important;
}

.meaasgeTitle_xttz_list,
.meaasgeTitle_dz_list,
.meaasgeTitle_sc_list,
.meaasgeTitle_fs_list {
  display: block;
  width: 100%;
  padding: 0 0.4rem;
  background: #ffffff;
  border-radius: 0.08rem 0.08rem 0.08rem 0.08rem;
  height: 5rem;
  overflow: auto;
}

.meaasgeTitle_xttz_list>div {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 0.24rem 0;
  border-bottom: 0.01rem solid #e5e6eb;
}

.meaasgeTitle_xttz_list>div>img {
  width: 0.4rem;
  margin-right: 0.12rem;
}

.meaasgeTitle_xttz_list>div>div>.MTXL_time {
  font-size: 0.14rem;
  color: #86909c;
  /* margin-bottom: 0.12rem; */
  padding-bottom: 0.08rem;
}

.meaasgeTitle_xttz_list>div>div>.MTXL_title {
  font-size: 0.16rem;
  color: #333;
}

.MTXL_title>span {
  color: #3fa4ed;
}

.message-item {
  display: flex;
  align-items: center;
}

.message-content {
  flex: 1;
}

.link-container {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.detail-link {
  margin-right: 10px;
  /* 调整链接之间的间距 */
  cursor: pointer;
}

/* 根据需要进行样式调整 */
.delete-action {
  cursor: pointer;
  color: red;
}

.MT_dz_list {}

.MT_dz_list>div {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0.24rem 0;
  border-bottom: 0.01rem solid #e5e6eb;
  position: relative;
}

.MT_dz_list>div>div {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
}

.MT_dz_list_imgUser {
  width: 0.4rem;
  height: 0.4rem;
  border-radius: 50%;
  margin-right: 0.12rem;
}

.MT_dz_list_imgWorks {
  width: 1.85rem;
}

.MT_dz_list_name {
  font-size: 0.16rem;
  color: #333;
}

.MT_dz_list_time {
  color: #86909c;
  font-size: 0.14rem;
}

.MT_dz_list_z {
  font-size: 0.14rem;
  color: #333;
  margin-top: 0.12rem;
}

.MT_dz_list_imgList {
  margin-top: 0.12rem;
}

.MT_dz_list_imgList>img {
  width: 0.4rem;
  margin-right: 0.12rem;
}

.MTFS_list_lx {
  font-size: 0.12rem;
  color: #333;
  padding: 0.06rem 0.16rem;
  border: 0.01rem solid #333333;
  border-radius: 0.04rem;
  margin-right: 0.16rem;
  background: #fff;
}

.MTFS_list_gz {
  background: #c01a26;
  border-radius: 0.04rem 0.04rem 0.04rem 0.04rem;
  padding: 0.06rem 0.16rem;
  border: 0rem solid #333333;
  color: #fff;
}

.tac {
  display: flex;
  align-items: center;
  justify-content: center;
  /* text-align: center; */
}

.wVC_list {
  display: flex;
  justify-content: space-between;
  margin-top: 0.2rem;
}

.wVC_list_l_userImg {
  width: 0.5rem;
  border-radius: 50%;
  margin-right: 0.12rem;
}

.wVC_list_l {
  display: flex;
  justify-content: flex-start;
}

.wVC_list_l_Title {
  display: flex;
  flex-direction: column;
}

.wVC_list_l_Title>div {
  display: flex;
  /* flex-direction: row-reverse; */
  align-items: center;
}

.wVC_list_l_T_T_name {
  font-size: 0.16rem;
  color: #333333;
  margin-right: 0.08rem;
}

.wVC_list_l_T_T_time {
  color: #86909c;
  font-size: 0.12rem;
}

.wVC_list_l_T_B {
  margin-top: 0.06rem;
}

.wVC_list_l_T_B_rz {
  color: #015243;
  background: #e1fefc;
  border-radius: 0.1rem;
  font-size: 0.12rem;
  padding: 0.02rem 0.16rem 0.02rem 0.04rem;
  display: flex;
  align-items: center;
}

.wVC_list_l_T_B_rz>img {
  width: 0.13rem;
  margin-right: 0.09rem;
}

.wVC_list_r {
  display: flex;
  align-items: center;
}

.wVC_list_r>button {
  padding: 0.06rem 0.16rem;
  font-size: 0.12rem;
  border-radius: 0.04rem;
}

.wVC_list_r_lx {
  border: 0.01rem solid #333333;
  color: #333333;
  margin-right: 0.16rem;
}

.wVC_list_r_gz {
  background: #c01a26;
  color: #ffffff;
  width: calc();
  border: 0rem solid #333333;
}

/* 弹出框 */
.zf_body {
  border-radius: 0.12rem;
}

.zf_body_top {
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.2rem;
}

.zf_body_top>span {
  color: #333333;
  font-size: 0.16rem;
}

.zf_body_top>img {
  width: 0.2rem;
}

.zf_body_title {
  color: #86909c;
  font-size: 0.14rem;
  text-align: center;
  margin-bottom: 0.12rem;
}

.zf_b_M {
  display: flex;
  justify-content: center;
  align-items: baseline;
}

.zf_b_M_title {
  font-size: 0.14rem;
  color: #000000;
}

.zf_b_M_number {
  font-size: 0.24rem;
  color: #c01a26;
}

.zf_b_M_n_icon {
  font-size: 0.14rem;
}

.zf_fs_body {
  margin-top: 0.2rem;
}

.zf_fs_title {
  color: #000000;
  font-size: 0.14rem;
  margin-bottom: 0.12rem;
}

.zf_fs_list {
  display: flex;
}

.zf_fs_list>div {
  position: relative;
  border-radius: 0.04rem;
  border: 1px solid #e5e6eb;
  padding: 0.08rem 0.24rem;
  margin-right: 0.12rem;
  display: flex;
  align-items: center;
}

.zf_fs_logo {
  width: 0.24rem;
  margin-right: 0.04rem;
}

.zf_fs_icon {
  width: 0.25rem;
  position: absolute;
  right: 0;
  bottom: 0;
}

.zf_fs_b {
  display: flex;
  justify-content: center;
}

.zf_fs_b>div {
  padding: 0.08rem 0.3rem;
  font-size: 0.14rem;
  border-radius: 0.08rem;
  border: 0.01rem solid #333333;
}

.zf_fs_b_qx {
  color: #333333;
}

.zf_fs_b>.zf_fs_b_qd {
  color: #ffffff;
  border: 0.01rem solid #c01a26;
  background: #c01a26;
  margin-left: 0.2rem;
}

.zf_fs_body {
  margin-bottom: 0.2rem;
}

/deep/.el-dialog__header {
  padding: 0 !important;
}

/deep/ .el-dialog.is-align-center {
  border-radius: 20px !important;
}
</style>
